export const SUITS = ['crak', 'bam', 'dot'];
export const SUIT_CHARS = { crak: '万', bam: '竹', dot: '●' };
export const SUIT_NAMES = { crak: 'Crak', bam: 'Bam', dot: 'Dot' };

export const WINDS = ['east', 'south', 'west', 'north'];
export const WIND_CHARS = { east: '東', south: '南', west: '西', north: '北' };
export const WIND_NAMES = { east: 'East', south: 'South', west: 'West', north: 'North' };

export const DRAGONS = ['red', 'green', 'white'];
export const DRAGON_CHARS = { red: '中', green: '發', white: '□' };
export const DRAGON_NAMES = { red: 'Red', green: 'Green', white: 'White' };

export const CHAR_DIRS = ['right', 'across', 'left', 'left', 'across', 'right'];
export const CHAR_LABELS = [
  'Pass 3 tiles RIGHT →',
  'Pass 3 tiles ACROSS ↕',
  'Pass 3 tiles LEFT ←',
  'Second pass: 3 LEFT ←',
  'Second pass: 3 ACROSS ↕',
  'Second pass: 3 RIGHT →',
];

// Seat order matching the existing monolith player-index layout:
//   index 0 = human (South), 1 = East, 2 = North, 3 = West.
// Turn order is (idx + 1) % 4 which yields East → North → West → South.
// This is preserved from the original app; see DECISIONS.md.
export const PLAYER_COUNT = 4;
export const HUMAN_INDEX = 0;

// The official 2026 hands live in src/engine/cards/nmjl2026.js (the fictional
// PATTERNS that used to live here were removed 2026-06-16; see DECISIONS).

export const DEFAULT_PLAYERS = [
  { name: 'Georgianna', isAI: false, seat: 'South' },
  { name: 'Emily', isAI: true, seat: 'East' },
  { name: 'Diane', isAI: true, seat: 'North' },
  { name: 'Linda', isAI: true, seat: 'West' },
];
